{
  "SRF": "srf@srf.ch",
  "RTR": "rtr@rtr.ch",
  "RSI": "info@rsi.ch",
  "RTS": "rts-digital-support@rts.ch"
}
